export default __webpack_public_path__ + "static/media/垂直对齐_align-vertically.f6ccb53d.svg";